$(document).ready(function () {
    optionsMenu.init();
});

var optionsMenu = {};

optionsMenu.setupDropdowns = function () {
    optionsMenu.headerDropdowns = new logicjs.optionsDropdown({
        containerClass: "c-options-dropdown",
        item: ".c-options-dropdown__item",
        toggleCtrl: ".c-options-dropdown__toggle",
        view: ".c-options-dropdown__view",
        hiddenClass: "c-options-dropdown__item--hidden",
        parentEmitUpdateFn: function (container, type) {
            if (optionsMenu.setupMobMenuActive) optionsMenu.updateParent(container, type);
        }
    });
};

optionsMenu.setupMobMenu = function () {
    optionsMenu.headerMobMenu = new logicjs.optionsDropdown({
        containerClass: "c-options-menu",
        item: ".c-options-menu__item",
        toggleCtrl: ".c-options-menu__toggle",
        view: ".c-options-menu__view",
        hiddenClass: "c-options-menu__item--hidden"
    });
};

optionsMenu.updateParent = function (container, type) {
    switch (type) {
        case "document click":
            optionsMenu.headerDropdowns.unbindDocClick();
            break;
        case "item click":
            var parent = container.parents('.' + optionsMenu.headerMobMenu.opts.containerClass),
                view = parent.find(optionsMenu.headerMobMenu.opts.view);

            optionsMenu.headerMobMenu.resetSelected(view);
            optionsMenu.headerMobMenu.openSelected(view);
            break;
    }
};

optionsMenu.windowResizeCheck = function () {
    window.addEventListener('resize', function () {
        optionsMenu.matchMediaCheck();
    });
};

optionsMenu.matchMediaCheck = function () {
    if (window.matchMedia) {
        if (window.matchMedia("(min-width: 768px)").matches) {
            if (optionsMenu.setupMobMenuActive) {
                optionsMenu.setupMobMenuActive = false;
                optionsMenu.headerDropdowns.enable();
                optionsMenu.headerMobMenu.disable();
            }
        } else {
            if (!optionsMenu.setupMobMenuActive) {
                optionsMenu.setupMobMenuActive = true;
                optionsMenu.headerMobMenu.enable();
                optionsMenu.headerDropdowns.enable();
            }
        }
    }
};

optionsMenu.init = function () {
    optionsMenu.setupMobMenu();
    optionsMenu.setupDropdowns();
    optionsMenu.windowResizeCheck();
    optionsMenu.matchMediaCheck();
};


